/** Appwrite `users` document role — guests see Customers, Product & Service Catalog (read-only), and Invoice. */
export function isGuestRole(user) {
  if (!user) return false;
  return String(user.role || '').trim().toLowerCase() === 'guest';
}

/** Full app access (no sidebar section locks). */
export function isAdminRole(user) {
  if (!user) return false;
  const role = String(user.role || '').trim().toLowerCase();
  return role === 'admin' || role === 'owner' || role === 'superadmin';
}

/**
 * Limited ops access: Home, Sales, Expenses, Invoice, Suppliers, Bank Details, Product Catalog, Attendance.
 * Stored as users.role = "ops" (and users.roles = "Operations" when enum requires it).
 */
export function isOpsRole(user) {
  if (!user) return false;
  const role = String(user.role || '').trim().toLowerCase();
  const roles = String(user.roles || '').trim().toLowerCase();
  return role === 'ops' || role === 'operations' || roles === 'operations';
}

/** Default landing path after login by role. */
export function getHomePathForUser(user) {
  if (isGuestRole(user)) return '/customers';
  if (isOpsRole(user)) return '/';
  return '/';
}
